import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import NavigationDrawer from './NavigationDrawer'
import Header from './Header'


const Layout = ({ children }) => {
  const identity = useSelector(state => state.identity)
  const { signedIn } = identity
  const location = useLocation()
  const isOnboarding = location.pathname === '/onboarding'

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {signedIn && !isOnboarding ? (
        <Box sx={{ display: 'flex', flexGrow: 1 }}>
          <NavigationDrawer />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              backgroundColor: 'background.default',
              minHeight: '100vh',
              pt: 0,
            }}
          >
            {children}
          </Box>
        </Box>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            backgroundColor: 'background.default',
          }}
        >
          {!signedIn && <Header />}
          {children}
        </Box>
      )}
    </Box>
  )
}

export default Layout
